import $ from "jquery";

const SPINNER_HTML = `
<div id="magazine_list_loader" class="col-12 justify-content-center text-center mt-3">
  <div class="spinner-border text-primary text-center" role="status"></div>
</div>`;

const FINISHED_HTML = `
<div class="col-12 magazine-finished-message">
  <p class="fs-small text-black-50 text-center mt-3">Alle Ergebnisse gesehen</p>
</div>`;

let magazinePage = 1;
let canLoadMagazines = true;

$(document).on("turbo:load", () => {
  initialiseMagazineScroll();
});

document.addEventListener("turbo:before-cache", () => {
  $(window).off("scroll.magazines");
  $("#magazine_list_loader").remove();
});

function initialiseMagazineScroll() {
  const $loadedList = $("#magazine_list");
  if ($loadedList.length === 0) {
    $(window).off("scroll.magazines");
    return;
  }

  magazinePage = 1;
  canLoadMagazines = true;

  $(window).off("scroll.magazines").on("scroll.magazines", async () => {
    if (!canLoadMagazines) return;
    if (!isOnMagazinesIndex()) return;

    const triggerPoint = $(document).height() - $(window).height() - 300;
    if ($(window).scrollTop() < triggerPoint) return;

    canLoadMagazines = false;
    if ($("#magazine_list_loader").length === 0) {
      $loadedList.append(SPINNER_HTML);
    }

    const nextPage = magazinePage + 1;
    try {
      const response = await getMagazineList(nextPage);
      const magazines = response && response.data && response.data.data ? response.data.data : [];
      const listElement = document.getElementById("magazine_list");
      const dataset = listElement ? listElement.dataset : {};
      const isDebug = dataset.isDebug === "true" || dataset.isDebug === true;
      const stdbHost = dataset.stdbHost || "";

      if (magazines.length > 0) {
        magazines.forEach((item) => {
          $loadedList.append(magazineCardHtml(item, { isDebug, stdbHost }));
        });
        magazinePage = nextPage;
        canLoadMagazines = true;
      } else {
        canLoadMagazines = false;
        if ($loadedList.find(".magazine-finished-message").length === 0) {
          $loadedList.append(FINISHED_HTML);
        }
      }
    } catch (error) {
      console.error("Unable to load magazines", error);
      canLoadMagazines = false;
    } finally {
      $("#magazine_list_loader").remove();
    }
  });
}

function isOnMagazinesIndex() {
  return window.location.pathname.startsWith("/magazines");
}

async function getMagazineList(page) {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: "10",
  });

  const debugParam = getUrlParameter("debug");
  if (debugParam) {
    params.append("debug", debugParam);
  }

  const response = await fetch(`/load-new-magazines?${params.toString()}`, {
    method: "GET",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });
  return response.json();
}

function getUrlParameter(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

function magazineCardHtml(item, { isDebug, stdbHost }) {
  const expiryString = item.stdb_web_expires_at || "";
  const expiryDate = expiryString ? new Date(expiryString) : new Date(Date.now() + 5 * 60 * 1000);
  const isExpired = expiryDate < new Date();
  const styleAttr = isDebug && isExpired ? ' style="opacity: 0.5; filter: grayscale(100%);"' : "";

  const publishedAtParam = buildPublishedAtParam(item.published_at);
  const fallbackHref = publishedAtParam
    ? `/magazines/${item.title_id}/${item.id}.pdf?${publishedAtParam}`
    : `/magazines/${item.title_id}/${item.id}.pdf`;
  const href = item.webview_url && item.webview_url.length > 0 ? item.webview_url : fallbackHref;

  const titleAttr = isDebug && isExpired && expiryString
    ? ` title="Erscheinung läuft ab am ${expiryString}"`
    : "";

  const dataAttrs = isDebug
    ? ` data-class="Magazine" data-id="${item.id}" data-stdb-web-expires-at="${expiryString}" data-stdb-publication-id="${item.stdb_publication_id || ""}"`
    : "";

  const issueLine = `${item.title} - ${item.issue_name}`;
  const debugInfo = isDebug ? buildDebugInfo(expiryString, item.stdb_publication_id, stdbHost) : "";
  const trackAttrs = item.track_name
    ? ` data-track-category="App" data-track-action="open_epaper" data-track-name="${item.track_name}"`
    : "";

  return `
<div class="col-md-3 col-6 text-center"${styleAttr}>
  <a class="link-dark text-decoration-none" href="${href}" target="_blank"${titleAttr}${dataAttrs}${trackAttrs}>
    <img class="img-fluid border" src="${item.image}" alt="${item.image}">
    <p class="fs-small mt-2 text-default-gray">
      ${issueLine}
      ${debugInfo}
    </p>
  </a>
</div>`;
}

function buildPublishedAtParam(publishedAt) {
  if (!publishedAt) return "";
  const date = new Date(publishedAt);
  if (Number.isNaN(date.getTime())) return "";
  return `published_at=${date.toISOString().slice(0, 10)}`;
}

function buildDebugInfo(expiryString, publicationId, stdbHost) {
  if (!publicationId) return "";

  const onclickHost = stdbHost ? `${stdbHost}/publications/${publicationId}` : "";
  const onclickAttr = onclickHost
    ? ` onclick="window.open('${onclickHost}', '_blank', 'width=1000,height=1000,top=100,left=100,resizable=no,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,directories=no,fullscreen=no')"`
    : "";

  let expiryHtml = "";
  if (expiryString) {
    const [datePart, timePart] = expiryString.split("T");
    const trimmedTime = timePart || "";
    expiryHtml = `<span style='white-space: nowrap'>${datePart}</span>${trimmedTime ? `T${trimmedTime}` : ""}`;
  }

  return `
      <span title="zur Ausgabe in der STDB springen"${onclickAttr} style="font-family: 'Fira Code', 'Source Code Pro', 'Consolas', 'Monaco', monospace; font-size: 0.5rem; line-height: 1.4; background-color: #f5f5f5; color: #333; padding: 0.5em; border-radius: 4px; overflow-x: auto;">
        stdb_web_expires_at:${expiryHtml}
      </span>`;
}
